export default "__VITE_ASSET__0bd22879__"